import { render, staticRenderFns } from "./WithDescription.vue?vue&type=template&id=2c6926cc"
import script from "./WithDescription.vue?vue&type=script&lang=js"
export * from "./WithDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports